import { render, staticRenderFns } from "./Episodesgroupmobile.vue?vue&type=template&id=4894af38&scoped=true&"
import script from "./Episodesgroupmobile.vue?vue&type=script&lang=js&"
export * from "./Episodesgroupmobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894af38",
  null
  
)

export default component.exports